import { render, staticRenderFns } from "./EventThanks.vue?vue&type=template&id=66efee36"
import script from "./EventThanks.vue?vue&type=script&lang=js"
export * from "./EventThanks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports